import Swiper from "swiper";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import { adjustedPx } from "../../assets/js/utils/helpers";
export default class ClientSlider {
    constructor(block) {
        this.clientSliderBlock = block;
        this.screenSettings = {
            sm: { width: adjustedPx(576), slidesPerView: 3.5, spaceBetween: 4 },
            md: { width: adjustedPx(744), slidesPerView: 4, spaceBetween: 4 },
            lg: { width: adjustedPx(992), slidesPerView: 8, spaceBetween: 8 },
        };
        this.initSlider();
    }
    initSlider() {
        const swiperContainer = this.clientSliderBlock.querySelector('.swiper');
        if (!swiperContainer)
            return;
        this.allNextButtons = Array.from(this.clientSliderBlock.querySelectorAll('.swiper-button-next'));
        this.allPrevButtons = Array.from(this.clientSliderBlock.querySelectorAll('.swiper-button-prev'));
        let options = {
            modules: [Autoplay, Navigation, Pagination],
            spaceBetween: 4,
            slidesPerView: 2.5,
            loop: false,
            autoplay: false,
            navigation: {
                nextEl: this.allNextButtons[0],
                prevEl: this.allPrevButtons[0],
            },
            breakpoints: this.getBreakpoints(),
        };
        this.swiper = new Swiper(swiperContainer, options);
        this.updateDisabledState(); // Initial button disabled check
        this.checkScreenSize(); // Initial screen size check
        // Update button disabled class
        this.swiper.on('afterInit', this.updateDisabledState.bind(this));
        this.swiper.on('slideChange', this.updateDisabledState.bind(this));
        // Handle all button clicks
        this.allNextButtons.forEach(button => {
            button.addEventListener('click', () => this.swiper.slideNext());
        });
        this.allPrevButtons.forEach(button => {
            button.addEventListener('click', () => this.swiper.slidePrev());
        });
        // Handle resize
        window.addEventListener('resize', this.checkScreenSize.bind(this));
    }
    // Generate breakpoints for swiper
    getBreakpoints() {
        const breakpoints = {};
        Object.keys(this.screenSettings).forEach((key) => {
            const setting = this.screenSettings[key];
            breakpoints[setting.width] = {
                slidesPerView: setting.slidesPerView,
                spaceBetween: setting.spaceBetween,
            };
        });
        return breakpoints;
    }
    // Update disabled class for buttons
    updateDisabledState() {
        const isBeginning = this.swiper.isBeginning;
        const isEnd = this.swiper.isEnd;
        this.allPrevButtons.forEach(button => {
            button.classList.toggle('swiper-button-disabled', isBeginning);
        });
        this.allNextButtons.forEach(button => {
            button.classList.toggle('swiper-button-disabled', isEnd);
        });
    }
    // Hide or show buttons
    toggleButtons(hide) {
        const toggleVisibility = (buttons, hide) => {
            buttons.forEach(button => {
                button.classList.toggle('hidden', hide);
            });
        };
        toggleVisibility(this.allPrevButtons, hide);
        toggleVisibility(this.allNextButtons, hide);
    }
    // Check the screen size and update the swiper settings
    checkScreenSize() {
        const windowWidth = window.innerWidth;
        const slideCount = this.swiper.slides.length;
        // find current screen size = compare window width to breakpoints
        const currentScreenSize = Object.keys(this.screenSettings).reverse().find(key => windowWidth >= this.screenSettings[key].width) || 'sm';
        // update swiper based on current screen size
        if (slideCount === this.screenSettings[currentScreenSize].slidesPerView) {
            this.swiper.params.autoplay = false;
            this.swiper.params.loop = false;
            this.swiper.update();
            this.toggleButtons(true);
        }
        else {
            this.swiper.params.autoplay = true;
            this.swiper.params.loop = true;
            this.swiper.update();
            this.toggleButtons(false);
        }
    }
}
const clientSliderBlocks = document.querySelectorAll('[data-client-slider-block]');
clientSliderBlocks.forEach((block) => new ClientSlider(block));
